// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1rqGS","col":"styles_col__1dQxr"};